import { UPDATE_PRODUCT_CUSTOMISATION, REMOVE_PRODUCT_CUSTOMISATION } from '../actions/product';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';

export const product = (state = { customisation: {} }, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_CUSTOMISATION:
      let customisation = {
        ...state.customisation,
        ...action.customisation,
      };

      if (customisation.bears) {
        customisation.bears = customisation.bears.map(bear => {
          try {
            return JSON.parse(bear);
          } catch (error) {
            return bear;
          }

        });
      }

      if (action.productKey === 'TJH') {
        customisation.country = customisation.country && customisation.country.toUpperCase();
        customisation.door = customisation.door && customisation.door.toString();
        customisation.lat = customisation.lat && parseFloat(customisation.lat);
        customisation.lng = customisation.lng && parseFloat(customisation.lng);
      }

      return {
        ...state,
        key: action.productKey,
        customisation: omitBy(customisation, isUndefined),
      };
    case REMOVE_PRODUCT_CUSTOMISATION:
      return {
        ...state,
        customisation: omit(state.customisation, action.customisationKeys)
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/client/js/store/reducers/product.js